import Vue from 'vue'
import VueRouter from 'vue-router'
import Hello from '../views/Hello.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'Hello',
        component: Hello
    },
    {
        path: '/usuarios',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "about" */ '../views/Profile.vue')
    },
    {
        path: '/consultas',
        name: 'Appoinments',
        component: () => import(/* webpackChunkName: "about" */ '../views/Appoinments.vue')
    },
    {
        path: '/carta-astral',
        name: 'AstralCard',
        component: () => import(/* webpackChunkName: "about" */ '../views/AstralCard.vue')
    },
    {
        path: '/contabilidad',
        name: 'Contact',
        component: () => import(/* webpackChunkName: "about" */ '../views/Contact.vue')
    },
    {
        path: '/nueva-consulta',
        name: 'NewConsult',
        component: () => import(/* webpackChunkName: "about" */ '../views/NewConsult')
    },
    {
        path: '/pago-consulta',
        name: 'PayConsultation',
        component: () => import(/* webpackChunkName: "about" */ '../views/PayConsultation')
    },
    {
        path: '/pago-consulta2',
        name: 'PayConsultation2',
        component: () => import(/* webpackChunkName: "about" */ '../views/PayConsultation2')
    }
]

const router = new VueRouter({
    base: process.env.BASE_URL,
    routes
})

export default router
